import { render, staticRenderFns } from "./EmployeeManager.vue?vue&type=template&id=8e4d0e58"
import script from "./EmployeeManager.vue?vue&type=script&lang=js"
export * from "./EmployeeManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports